export interface GteVoiceStatus {
  isEnabled: boolean;
}

function getHeaders(): HeadersInit {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let msg = `API error: ${response.status}`;
    try {
      const body = await response.json();
      msg = body?.error?.message || body?.ErrorMessage || msg;
    } catch { /* ignore */ }
    throw new Error(msg);
  }
  return response.json() as Promise<T>;
}

export async function getGteVoiceStatus(): Promise<GteVoiceStatus> {
  const response = await fetch(`${process.env.REACT_APP_Auth_Url}/api/GTEVoice/integration/status`, {
    method: 'GET',
    headers: getHeaders(),
  });
  const data = await handleResponse<{ IsEnabled: boolean }>(response);
  return { isEnabled: data.IsEnabled };
}

export async function enableGteVoice(): Promise<void> {
  const response = await fetch(`${process.env.REACT_APP_Auth_Url}/api/GTEVoice/integration/enable`, {
    method: 'POST',
    headers: getHeaders(),
  });
  await handleResponse<unknown>(response);
}

export async function disableGteVoice(): Promise<void> {
  const response = await fetch(`${process.env.REACT_APP_Auth_Url}/api/GTEVoice/integration/disable`, {
    method: 'POST',
    headers: getHeaders(),
  });
  await handleResponse<unknown>(response);
}
